import { useField } from 'formik'
import React from 'react'
import './styles.css';
const TextInputPasaporte = ({mright,widthInput,...props}) => {
    const [field,meta]= useField({...props , type:"text"});
    return (
        <div className = "containerInput">
            <input type = "text" className = "inputTextPasaporte input"{...field} {...props} style = {{ marginRight:`${mright}px`, width :`${widthInput}px`} }/>
            {meta.touched && meta.error? <p className = "errors">{meta.error}</p> : null}
        </div>
    )
}
export default TextInputPasaporte;